import { UniqueIdentifier } from '@dnd-kit/core';
import React from 'react';

import { Stack, Text } from '@eluve/components';
import { BlockType } from '@eluve/llm-outputs';

import { BlockTypeIcon } from './BlockTypeIcon';
import { templateBuilderStore } from './templateBuilderStore';

const blocks: {
  name: string;
  tip: string;
  type: BlockType;
}[] = [
  {
    type: 'group',
    name: 'Group',
    tip: 'Container for other blocks',
  },
  {
    type: 'text',
    name: 'Text block',
    tip: 'Freeform text',
  },
  {
    type: 'checkbox',
    name: 'Checkboxes',
    tip: 'List of checkbox options',
  },
];

export const BlockPicker: React.FC<{
  parentId: UniqueIdentifier | null;
  index?: number;
  showTips?: boolean;
}> = ({ parentId, index, showTips }) => {
  const onBlockClick = (blockType: BlockType) => {
    templateBuilderStore.send({
      parentId,
      type: 'addBlock',
      blockType,
      placeAtIndex: index,
    });
  };

  return (
    <Stack gap={3} direction="horizontal" align="stretch">
      {blocks.map(({ name, tip, type }, i) => {
        return (
          <React.Fragment key={i}>
            <Stack
              align="start"
              className="rounded-lg border p-4 hover:cursor-pointer hover:bg-bg-secondary"
              gap={1}
              onClick={() => onBlockClick(type)}
            >
              <Stack
                gap={3}
                justify={showTips ? 'start' : 'center'}
                direction="horizontal"
              >
                <BlockTypeIcon type={type} />
                <Text inline>{name}</Text>
              </Stack>
              {showTips && (
                <Text color="tertiary" size="xs">
                  {tip}
                </Text>
              )}
            </Stack>
          </React.Fragment>
        );
      })}
    </Stack>
  );
};
